import { EpiVariationBlock, LoadingStatus } from '@api/types';
import { ProductCard } from '@components';

// TYPES
//-------

export type VariationProps = LoadingStatus & {
  block?: EpiVariationBlock;
};

// COMPONENTS
//------------

/**
 * Map Product Variation to product card
 */
export const Variation = ({ block = {}, isLoading }: VariationProps) => {
  return (
    <ProductCard
      name={block.name}
      grossPrice={block.grossPrice}
      discountPrice={block.discountPrice}
      image={block.mainImage}
      isLoading={isLoading}
      code={block.code ?? ''}
      url={block.contentLink?.url}
      productLabel={block.productLabel}
      packageIncluded={block.packageIncluded}
    />
  );
};
